import type { IconSvgObject } from './types';

const Tick02Icon: IconSvgObject = [
  ["path", { d: "M4.25 13.5L8.75 18L19.75 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Tick02Icon;
